// 业务订单
export default {
  agentHN: {
    column: {
      orderType: '订单类型',
      orderNo: '订单编号',
      businessType: '经营方式',
      signDate: '签约日期',
      supplierNo: '供应商编码',
      supplierName: '供应商',
      customerNo: '客户编码',
      customerName: '签约客户',
      performancePeriod: '履约期',
      latestPerformanceDate: '最晚履约期',
      isCreditsale: '是否赊销', //1赊销,0不赊销
      creditInterestRate: '赊销利率(%)',
      isPrepay: '是否预付', //1预付,0不预付
      prepayAmount: '预付金额',
      marginPercentage: '保证金比率(%)',
      marginAmount: '保证金',
      currencyCode: '货币代码',
      currencyName: '货币',
      interestRate: '利率(%)',
      purchasePriceType: '采购单价类型',
      purchasePriceTypePlaceholder: '请选择采购单价类型',
      supplierContactPerson: '供应商联系人',
      supplierContactTel: '联系方式', //供应商
      operaterNo: '操作人编号',
      operaterName: '操作人',
      customerContactPerson: '客户联系人',
      supplierContactPersonPlaceholder: '自动生成',
      supplierContactTelPlaceholder: '自动生成',
      customerContactYel: '联系方式', //客户
      salesmanNo: '业务员编号',
      salesmanName: '业务员',
      paymentTimes: '全额一次性支付', //选中则为1
      isPresale: '预售', //选中则为1
      remark: '备注',
      orderStatus: '订单状态',
      orderCompanyNo: '合同公司编码',
      orderCompanyName: '合同公司名称',
      orderDepartmentNo: '业务部门名称',
      orderDepartmentName: '业务部门名称',
      supplierType: '供应商类别',
      customerType: '客户类别',
      adjustedMarginAmount: '保证金金额(调整后)',
      purchaseAmount: '采购金额',
      salesAmount: '销售金额',
      paidAmount: '已付款金额',
      receiptAmount: '已收款金额',
      isPrepayPlaceholder: '是/否',
    },
  },
};
